import { Text } from 'braid-design-system';
import startCase from 'lodash/startCase';
import React from 'react';

import ExternalLink from 'src/components/ExternalLink/ExternalLink';
import Routes from 'src/config/routes';

interface Props {
  suffix: string;
}

const BulletLink = ({ suffix }: Props) => (
  <Text>
    <ExternalLink destination={`${Routes.BUSINESS_RESOURCES}${suffix}`}>
      {startCase(suffix)}
    </ExternalLink>
  </Text>
);

export default BulletLink;
